<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Schema Transaction Types"
              bc1="App"
              bc2="Schema Transaction Types"
              bc3="List"
              path="schemas"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a href="javascript:void(0)">Schema</a></li>
                      <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Action</th>


                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in transaction_types" :key="index">

                      <td>{{index+1}}</td>
                      <td>{{item.name}}</td>
                      <td v-if="item.pivot.status == 1"><span class="badge badge-success badge-sm badge-glow">Active</span></td>
                      <td v-else><span class="badge badge-danger badge-sm badge-glow">Inactive</span></td>
                      <td>
                        <button type="button" @click="showLimitSettings(item,index)" class="btn btn-warning btn-sm">Settings</button>
                        <button type="button" @click="showCharges(item,index)" class="btn btn-primary  ml-1 btn-sm">Charges</button>
                      </td>



                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {
    var acquiringSchemaDetailsList = this.$store.getters.getByKey(
        "acquiringSchemaDetailsList"
    );


    var schemaAcquiringTransactionTypes = this.$store.getters.getByKey(
        "schemaAcquiringTransactionTypes"
    );

    this.currentBreadCrumb.push(acquiringSchemaDetailsList.row.name+'/'+acquiringSchemaDetailsList.row.code)
    this.currentBreadCrumb.push(schemaAcquiringTransactionTypes.row.aquiring.name+'/'+schemaAcquiringTransactionTypes.row.aquiring.code)


    this.transaction_types = schemaAcquiringTransactionTypes.row.aquiring.transaction_types
    this.aquiringId = schemaAcquiringTransactionTypes.row.id
  },
  data() {
    return {
      transaction_types:[],
      selectedType:null,
      aquiringId:'',
      currentBreadCrumb:[]

    };
  },
  methods: {
    showLimitSettings(item,index){
      let data = {
        index: index,
        row: item,
        key: "schemaAcquiringTransactionTypesLimits"
      };
      this.$store.dispatch("set", data);
      this.$router.push({name: 'schema-aquiring-limits',params: {acquiringId : btoa(this.aquiringId)}})
    },
    showCharges(item,index){
      let data = {
        index: index,
        row: item,
        key: "schemaAcquiringTransactionTypesCharges"
      };
      this.$store.dispatch("set", data);
      this.$router.push({name: 'schema-transction-type-charges',params: {acquiringId : btoa(this.aquiringId)}})
    },
  },
  watch:{

  }
};
</script>

